import {
    useState,
    useEffect
}
from "react";

import {
    functions
}
from "../../../constants/common-functions";

export default function useSpaceOrgDashboardBuilding(facilityId)
{
    const [dashboard, setDashboard] =
        useState(null);
		
		

		useEffect(
		    function()
		    {
		        if(!facilityId)
		        {
		            return;
		        }

		        functions.getObjectFromAjax(
		            "/resolutionsoftwareplatform/spaceorgdashboardbuilding?facilityId=" +
		            facilityId,
		            function(obj)
		            {
		                setDashboard(
		                    obj
		                );
		            },
		            null
		        );
		    },
		    [
		        facilityId
		    ]
		);

    if(!dashboard)
    {
        return {
            kpis: {},
            spaceBreakdown: [],
            topBuildings: [],
            topSpaces: [],
            buildingBreakdown: [],
            selectedBuilding: null,
            topFloors: []
        };
    }

    const kpis =
        dashboard.kpis;

		const spaceBreakdown =
		   dashboard.spaceBreakdown;

    const topFloors =
        dashboard.topFloors;

    const selectedBuilding =
    {
        id:
            dashboard.selectedBuildingId,

        name:
            dashboard.selectedBuildingName
    };

    const topSpaces =
        [];

    const buildingBreakdown =
        [];

    const topBuildings =
        [];

    return {
        kpis,
        spaceBreakdown,
        topBuildings,
        topSpaces,
        buildingBreakdown,
        selectedBuilding,
        topFloors
    };
}